import { FiBriefcase } from 'react-icons/fi';

const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key);

const isCurrentExperience = (item = {}) => {
    if (hasOwn(item, 'completed')) return item.completed === false || Number(item.completed) === 0;
    return /actualidad|presente|actual/i.test(String(item.period || ''));
};

const formatMonthYear = (value) => {
    if (!value) return '';
    const raw = String(value).trim();
    const date = /^\d{4}-\d{2}-\d{2}$/.test(raw)
        ? new Date(`${raw}T12:00:00`)
        : new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;

    const text = new Intl.DateTimeFormat('es-AR', { month: 'short', year: 'numeric' })
        .format(date)
        .replace('.', '');
    return text.charAt(0).toUpperCase() + text.slice(1);
};

const formatExperiencePeriod = (item = {}) => {
    const start = formatMonthYear(item.start_date);
    const end = formatMonthYear(item.end_date);
    const current = isCurrentExperience(item);

    if (start) {
        if (current) return `${start} — Actualidad`;
        if (end) return `${start} — ${end}`;
        return start;
    }

    if (item.period) return current ? `${String(item.period)} — Actualidad` : String(item.period);
    return current ? 'Actualidad' : '';
};

export const ExperienceSection = ({ experience = [] }) => (
    <section id="experiencia" className="PB__section PB__experience_section">
        <div className="PB__experience_halo PB__experience_halo--a" aria-hidden="true" />
        <div className="PB__experience_halo PB__experience_halo--b" aria-hidden="true" />
        <div className="PB__experience_orbit" aria-hidden="true" />

        <div className="PB__container PB__relative">
            <div className="PB__section_header PB__section_header--career">
                <div>
                    <div className="PB__section_kicker">Experiencia</div>
                    <h2 className="PB__section_title">trayectoria <em>·</em></h2>
                </div>
            </div>

            <div className="PB__career_path">
                <span className="PB__career_axis" aria-hidden="true" />

                {experience.map((item, index) => {
                    const current = isCurrentExperience(item);
                    const period = formatExperiencePeriod(item);

                    return (
                        <article
                            className={`PB__career_stop PB__career_stop--tone-${index % 4} ${current ? 'is-current' : ''}`}
                            key={item.id || `${item.company}-${item.period || item.start_date || index}`}
                        >
                            <div className="PB__career_card">
                                {period && (
                                    <div className="PB__career_card_top">
                                        <span className="PB__career_period">{period}</span>
                                    </div>
                                )}

                                <div className="PB__career_company">
                                    <FiBriefcase />
                                    <span>{item.company}</span>
                                </div>

                                <h3>{item.role}</h3>
                                <p>{item.description}</p>
                            </div>

                            <div className="PB__career_marker" aria-label={current ? 'Experiencia laboral actual' : undefined} aria-hidden={current ? undefined : true}>
                                <span />
                            </div>
                        </article>
                    );
                })}
            </div>
        </div>
    </section>
);
